export const apiName: string = 'tipos-deslocamentos';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamento-tipos/data.service.ts
 **/